export const gdpr = {
  routes: [
    {
      path: "/electronic-storage",
      component: () => import("../organization-electronic-storage-view"),
    },
  ],
};
